import { IconButton, Tooltip } from "@mui/material/node";
import { useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { ElementsViewDialog } from "../../Dialogs/elementsViewDialog";
import IosShareIcon from '@mui/icons-material/IosShare';
import ListAltIcon from '@mui/icons-material/ListAlt';
import NodeCanvasLogo from '../../../assets/NodeCanvasLogo.svg';
import FacebookIcon from '@mui/icons-material/Facebook';
import XIcon from '@mui/icons-material/X';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import EmailIcon from '@mui/icons-material/Email';
import LinkIcon from '@mui/icons-material/Link';

export const ShareProjectButton = (props) => {
    const [showDialogOpen, setShowDialogOpen] = useState(false);
    const theme = useTheme();

    return (
        <>
                {/* Share Dialog */}
                {showDialogOpen && (
                    <div
                        style={{
                            position: "fixed",
                            top: 0,
                            left: 0,
                            width: "100vw",
                            height: "100vh",
                            backgroundColor: "rgba(0,0,0,0.3)",
                            zIndex: 1400,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center"
                        }}
                        onClick={() => setShowDialogOpen(false)}
                    >
                        <div
                            style={{
                                background: "#fff",
                                borderRadius: 12,
                                minWidth: 300,
                                padding: 24,
                                boxShadow: "0 2px 16px 0 rgba(0,0,0,0.18)",
                                zIndex: 1500,
                                position: "relative",
                                display: "flex",
                                flexDirection: "column",
                                gap: 20
                            }}
                            onClick={e => e.stopPropagation()}
                        >
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                <div style={{ fontWeight: 600, fontSize: 18, marginBottom: 8 }}>Share Project</div>
                                <button
                                    onClick={() => setShowDialogOpen(false)}
                                    style={{
                                        background: "none",
                                        border: "none",
                                        fontSize: 22,
                                        cursor: "pointer",
                                        color: theme.palette.text.secondary
                                    }}
                                    aria-label="Close Share Dialog"
                                >
                                    &#x2716;
                                </button>
                            </div>
                            <div style={{ display: 'flex', gap: 18, flexWrap: 'wrap', justifyContent: 'center' }}>
                                {/* Facebook */}
                                <Tooltip title="Share on Facebook">
                                    <a
                                        href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(window.location.href)}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{ color: "#1877f3" }}
                                    >
                                        <FacebookIcon sx={{width: 36, height: 36 }} />
                                    </a>
                                </Tooltip>
                                {/* Twitter/X */}
                                <Tooltip title="Share on Twitter/X">
                                    <a
                                        href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(window.location.href)}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{ color: "#1da1f2" }}
                                    >
                                        <XIcon sx={{width: 36, height: 36}}/>
                                    </a>
                                </Tooltip>
                                {/* LinkedIn */}
                                <Tooltip title="Share on LinkedIn">
                                    <a
                                        href={`https://www.linkedin.com/shareArticle?url=${encodeURIComponent(window.location.href)}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{ color: "#0077b5" }}
                                    >
                                        <LinkedInIcon sx={{width: 36, height: 36}}/>
                                    </a>
                                </Tooltip>
                                {/* WhatsApp */}
                                <Tooltip title="Share on WhatsApp">
                                    <a
                                        href={`https://wa.me/?text=${encodeURIComponent(window.location.href)}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{ color: "#25d366" }}
                                    >
                                        <WhatsAppIcon sx={{width: 36, height: 36}}/>
                                    </a>
                                </Tooltip>
                                {/* Email */}
                                <Tooltip title="Share via Email">
                                    <a
                                        href={`mailto:?subject=${encodeURIComponent("Check out this project!")}&body=${encodeURIComponent(window.location.href)}`}
                                        style={{ color: "#4285f4" }}
                                    >
                                        <EmailIcon sx={{width: 36, height: 36}}/>
                                    </a>
                                </Tooltip>
                                {/* Copy Link */}
                                <Tooltip title="Copy link to clipboard">
                                    <button
                                        style={{
                                            background: "none",
                                            border: "none",
                                            padding: 0,
                                            margin: 0,
                                            cursor: "pointer",
                                            color: theme.palette.mode === 'dark' ? "#ccc" : "#333"
                                        }}
                                        onClick={async () => {
                                            try {
                                                await navigator.clipboard.writeText(window.location.href);
                                                alert("Link copied to clipboard!");
                                            } catch (e) {
                                                alert("Failed to copy link.");
                                            }
                                        }}
                                        aria-label="Copy link"
                                    >
                                        <LinkIcon sx={{width: 36, height: 36}}/>
                                    </button>
                                </Tooltip>
                            </div>
                        </div>
                    </div>
                )}


                <IconButton aria-label="Refresh layout" onClick={() => { setShowDialogOpen(true); }} color="inherit" sx={{ m: 0.5 }}>
                    <Tooltip title="Share project">
                        <IosShareIcon sx={{ color: theme.palette.menuIcon.main }} />
                    </Tooltip>
                </IconButton>
        </>
    );
}
